import JSZip from 'jszip';

export function saveAs(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

/**
 * @public — ported unchanged from the standalone tool, where this is exported but never actually
 * called (the standalone `GenerateStep.tsx` builds its own flat `JSZip` inline instead of using
 * this folder-nesting helper). Kept for parity with the source rather than dropped as dead code.
 */
export async function createProjectZip(
  companyName: string,
  logoPng: Blob,
  exportAssetsDocx: Blob,
  titlePageJpeg: Blob,
  titlePageDocx: Blob,
): Promise<Blob> {
  const zip = new JSZip();
  const folderName = companyName.trim() || 'Company Name';
  const folder = zip.folder(folderName);

  if (folder) {
    folder.file('company_logo.png', logoPng);
    folder.file('export_assets.docx', exportAssetsDocx);
    folder.file('title_page_image.jpeg', titlePageJpeg);
    folder.file('title_page.docx', titlePageDocx);
  }

  return zip.generateAsync({ type: 'blob' });
}
